{
  "version": 1,
  "asset_id": "4cf2a2cd-bf69-4308-ba01-b17dda098caa",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/4cf2a2cd-bf69-4308-ba01-b17dda098caa/hero-new-1280.jpg",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/4cf2a2cd-bf69-4308-ba01-b17dda098caa/hero-new-1280.jpg",
  "original_filename": "hero-new-1280.jpg",
  "size": 96861,
  "content_type": "image/jpeg",
  "created_at": "2026-07-24T08:10:48Z"
}
